/**
 @ngdoc service
 @name i18nService

 @description
 en_GB:Internationalisation/en_US:Internationalization
 Collects i18n from the server. Trying to make i18n as easy as it's counter part g.message()
 http://docs.grails.org/3.1.1/ref/Tags/message.html

 @example

 // Preload your translation and expose the service to your ctrl model
 this.i18nService = i18nService.preLoadI18nValues({
     'default.button.search.label':               {default:'Search'},
     'spinner.alt':                               {default:'Loading...'},
     'default.actions.label':                     {default:'Actions'}
  });

 // Alternative preload your translation and expose the service to your ctrl model
 this.i18nService = i18nService.preLoadI18nValues({
     'default.button.search.label':               'Search',
     'spinner.alt':                               'Loading...',
     'default.actions.label':                     'Actions'
  });

 // Collect using default as the key. Prerequisites: Value must be pre-loaded and all default values are unique
 {{::i18nService.messageByDefault('Sort by {0}', 'Argument One') }}
 {{::i18nService.msgByDefault('Sort by {0}', 'Argument One') }}

 // Standard usage within page if not pre-loading
 {{::i18nService.message('default.button.search.label', 'Search') }}
 {{::i18nService.msg('default.button.search.label', 'Search') }}

 // No Default specified. Not desired, but acceptable.
 {{::i18nService.message('default.button.search.label') }}
 {{::i18nService.msg('default.button.search.label') }}

 // Using arguments
 {{ i18nService.message('default.filterTable.sortBy.label', 'Sort by {0}', 'Argument One') }}
 {{ i18nService.msg('default.filterTable.sortBy.label', 'Sort by {0}', 'Argument One') }}

 */
var i18nService = function(ajaxCall, logService) {
    var logObj = logService.init('i18nService',false);

    this.warned = {};
    this.i18nUrl = I18N_URL;

    /**
     * Declare any frequent use i18n values here. The  system will collect these early on start up
     * It's unlikely a User will switch between different locals so instead will store cache en_GB values and refresh which locale is switched
     * @type {{ (code: string) : {default: string}, (code: string) : {default: string}, (code: string) : {default: string}, ... }}
     */
    this.i18n = {
        common:{
            'spinner.alt': 'Loading...',
            'default.actions.label': 'Actions'
        },
        //values key'ed by their code value
        byCode: {},
        //values key'ed by their default value
        byDefault: {},
        loaded: false
    };

    /**
     * Initializer method - Current not required
     */
    this.init = function(){
        logObj.logTab('init()',[]);
        //set initial values
        //setI18nLabels(this.i18n.code);
        logObj.logTab('init()',[],this.i18n);
    };

    /**
     * Provide a pre-loaded map of i18n. This is the most efficient use of this service code
     * @param i18nMap
     * @returns {i18nService}
     */
    this.preLoadI18nValues = function(i18nMap){
        logObj.logTab('preLoadI18nValues()',i18nMap);
        if(this.i18n && this.i18n.byCode && this.i18n.byDefault) {
            if(Object.keys(this.i18n.byDefault).length === 0){
                //No i18n byDefault or i18n byCode has been declared, so merge the common i18n values with the requested i18n values
                var common = this.i18n.common;
                Object.keys(common).forEach(function(key){
                    i18nMap[key] = common[key];
                });
            }
            collectI18nLabels(i18nMap, this.i18n, this.i18nUrl, this.warned);
        } else {
            console.warn('initial i18n is undefined');
        }
        logObj.logTab('preLoadI18nValues()',[],this.i18n);
        return this;
    };

    /**
     * Works similar to how grails message works
     * @param code
     * @param defaultValue
     * @param args [] - coming soon
     * @returns {string}
     */
    this.message = function(code,defaultValue,args){
        logObj.logTab('message()',[code,defaultValue,args]);
        var message;
        //collect the object by code
        var i18nByCode =  this.i18n.byCode[code];
        if( i18nByCode && i18nByCode.value ){
            message = i18nByCode.value;
        } else {
            message = addMissingCode(code, defaultValue, this.i18n, this.i18nUrl, this.warned);
        }
        if(message!=undefined){
            message = replaceArgs(message, args);
        } else {
            message = code;
        }
        logObj.logTab('message()',[],message);
        return message;
    };

    /**
     * Shorthand version of above
     * @param code
     * @param defaultValue
     * @param args
     * @returns {string}
     */
    this.msg = function(code, defaultValue, args) {
        return this.message(code,defaultValue,args);
    };

    /**
     * Collect using default as the key. Prerequisites: Value must be pre-loaded and all default values are unique
     * @returns {string}
     */
    this.msgByDefault = function(defaultValue, args){
        logObj.logTab('msgByDefault()',[defaultValue,args]);
        var message;
        //collect the object by default
        var i18nByDefault =  this.i18n.byDefault[defaultValue];
        if(i18nByDefault){
            message = i18nByDefault.value;
        } else {
            console.warn('Developer: Please use preLoadI18nValues( {\'unknown\':{default:\''+defaultValue+'\'}} ) to improve efficiency');
        }
        if(message!=undefined){
            message = replaceArgs(message, args);
        } else {
            message = defaultValue;
        }
        logObj.logTab('msgByDefault()',[defaultValue,args], message);
        return message;
    };

    /**
     * Collect using default as the key. Prerequisites: Value must be pre-loaded and all default values are unique
     * @returns {string}
     */
    this.messageByDefault = function(defaultValue, args){
        return this.msgByDefault(defaultValue,args);
    };

    /**
     * Will eventually get i18n from server
     * TODO: More work on this in future to load these from a i18n service
     */
    var collectI18nLabels = function(i18nMap, i18n, i18nUrl, warned){
        logObj.logTab('collectI18nLabels()', [i18nMap, i18n, i18nUrl, warned]);
        if(i18nMap && i18n) {
            var i18nMapToCollect = getI18nMapToCollect(i18nMap, i18n);
            if (i18nMapToCollect != undefined) {
                if (i18nUrl != undefined) {
                    //Wrap the data in a map keyed by i18nCodes . This is because otherwise Grails will manipulate data keyed with dots.
                    ajaxCall.getData(i18nUrl, {i18nCodes: i18nMapToCollect}).then(function (response) {
                        if (response.data && response.data.i18nCodes) {
                            logObj.log('ajaxCall.getData() response', response);
                            setEachI18n(response.data.i18nCodes, i18n);
                            i18n.loaded = true;
                        } else {
                            setI18nFailover(i18nMapToCollect, 'AJAX returned no response', i18nUrl, i18n, warned);
                        }
                    }, function (response) {
                        setI18nFailover(i18nMapToCollect, 'AJAX Failed:', response.data, i18n, warned);
                    });
                } else {
                   setI18nFailover(i18nMapToCollect, 'No i18nUrl specified', null, i18n, warned);
                }
            }
        } else {
            console.warn('collectI18nLabels() has been called incorrectly')
        }
        logObj.logTab('collectI18nLabels() returns',[], i18n);
    };

    var setEachI18n = function(i18nMapCollected, i18n){
        logObj.log('setEachI18n()',[i18nMapCollected, i18n]);
        for(var code in i18nMapCollected){
            //set each value return into our cache
            setI18n(i18nMapCollected, i18n, code)
        }
    };

    var setI18n = function(i18nMapCollected, i18n, code){
        logObj.log('setI18n()',[i18nMapCollected, i18n, code]);
        var i18nByCode = i18n.byCode[code], i18nCollected = i18nMapCollected[code];
        //if there's a value set the value
        i18nByCode.value = (i18nCollected.value) ? i18nCollected.value : i18nCollected.default;
        logObj.log('setI18n() code',code);
        logObj.log('setI18n() i18nByCode.value',i18nByCode.value);
        //if there's a default
        if(i18nByCode.default) {
            //pass the reference of the object
            i18n.byDefault[i18nByCode.default] = i18nByCode;
        }
    };

    var createI18nMap = function(code,defaultVal){
        return {code: code, default: defaultVal, value: defaultVal};
    };

    /**
     * Gets any i18n codes that have not yet been requested from server side
     * @param i18nMap
     * @param i18n
     * @returns {{}}
     */
    var getI18nMapToCollect = function( i18nMap, i18n ){
        logObj.logTab('getI18nMapToCollect()', [i18nMap,i18n] );
        var i18nMapToCollect = {}, i18nMapValue;
        for(var code in i18nMap){
            i18nMapValue = i18nMap[code];
            if(typeof i18nMapValue ==='string'){
                //reformat the string into the correct format of an object
                i18nMapValue = createI18nMap(code,i18nMapValue);
            } else if( !i18nMapValue.hasOwnProperty('code')  ){
                i18nMapValue.code = code;
            }
            if( !i18n.byCode[code] ){
                //add it to our map if it does not exist
                i18n.byCode[code] = i18nMapValue;
                //pop it into our to be collected list
                i18nMapToCollect[code] = i18nMapValue;
            }
        }
        logObj.logTab('getI18nMapToCollect()', [i18nMap,i18n], i18nMapToCollect );
        return i18nMapToCollect;
    };

    var setI18nFailover = function(i18nMapToCollect, warningMessage, otherUsefulInfo, i18n, warned){
        logObj.logTab('setI18nFailover()', [i18nMapToCollect, warningMessage, otherUsefulInfo, i18n, warned] );
        if(warned[warningMessage]==undefined) {
            warned[warningMessage] = true;
            console.warn(warningMessage, otherUsefulInfo);
        }
        setEachI18n(i18nMapToCollect, i18n);
        i18n.loaded = true;
        logObj.logTab('setI18nFailover()', [], i18n );
    };

    var addMissingCode = function(code, defaultValue, i18n, i18nUrl, warned){
        logObj.logTab('addMissingCode()', [code, defaultValue, i18n, i18nUrl, warned] );
        console.warn('Developer: Please use i18nService.preLoadI18nValues( {\''+code+'\':\''+defaultValue+'\'} ) to improve efficiency');
        var i18nMap = {};
        i18nMap[code] = createI18nMap(code,defaultValue);
        collectI18nLabels( i18nMap, i18n, i18nUrl, warned );
        var rtnValue = i18nMap[code].value;
        logObj.logTab('addMissingCode()', [code, defaultValue, i18n, i18nUrl, warned], rtnValue );
        return rtnValue;
    };

    var replaceArgs = function(message, args){
        logObj.logTab('replaceArgs()', [message, args] );
        var rtnMessage = message;;
        //This part is intentionally not cached as the args may be dynamic
        if(rtnMessage){
            if(args) {
                var find, replacement;
                for (var idx in args) {
                    find = '{' + idx + '}';
                    replacement = args[idx];
                    logObj.log('find', find, false );
                    logObj.log('in message', rtnMessage, false );
                    logObj.log('replacement', replacement, false );
                    rtnMessage = rtnMessage.replace( find, replacement );
                }
            }
        } else {
            rtnMessage = 'empty';
        }
        logObj.logTab('replaceArgs()', [message, args], rtnMessage  );
        return rtnMessage;
    };
}
i18nService.$inject = ['ajaxCall', 'logService'];
angular.module('app').service('i18nService', i18nService);